import { FC } from 'react';

import FlavorListing from 'components/main/FlavorSystem';

const Flavor: FC = () => <FlavorListing />;

export default Flavor;
